import React from 'react';
import { connect } from 'react-redux';
import ToolTip from 'react-portal-tooltip';
import ReactTooltip from 'react-tooltip';
import Timestamp from "react-timestamp"
import moment from "moment"
import PropTypes from 'prop-types';

export class Sensor extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tooltipOpen: false
		}
	}
	onMouseEnter() {
		this.setState({ tooltipOpen: true })
	}
	onMouseLeave() {
		this.setState({ tooltipOpen: false })
	}
	onMouseDown(e) {
		e.stopPropagation();
		e.preventDefault();
		if (typeof this.props.onMouseDown == "function") {
			this.props.onMouseDown(e, this.props.sensor);
		}
	}
	componentWillReceiveProps(nextProps) {
		if (nextProps.dragged && this.state.tooltipOpen) {
			this.setState({ tooltipOpen: false })
		}
	}
	render() {
		let sensor = this.props.sensor;
		let parentName = null;
		if (sensor.id) {
			if (this.props.nodeMap[sensor.id] && this.props.nodeMap[sensor.id].parent) {
				parentName = this.props.nodeMap[sensor.id].parent.info.name;
			}
		}
		let style = { left: sensor.xpercent + '%', top: sensor.ypercent + '%' };
		if (this.props.dragged) {
			style = { left: this.props.draggingX + '%', top: this.props.draggingY + '%' };
		}
		let className = 'point';
		// after one hour of offline turn the sensor into faulty one to indicate that it need mainetenance
		if (sensor.registered && (sensor.lastonl + 60 * 60 > moment().unix())) {
			if (sensor.faulty) {
				className += ' faulty';
			} else {
				if (sensor.inuse) {
					className += ' inuse';
				} else if (sensor.standby) {
					className += ' standby';
				}
			}
		} else {
			className += ` unregistered`
		}
		if (this.props.viewFilter) {
			if (this.props.viewFilter.code == "LIVE" && (!sensor.registered || sensor.faulty)) {
				// hide broken / unregistered sensor in live view.
				className += ` hidden`;
			}
			if (this.props.viewFilter.code == "MAINTENANCE" && (sensor.registered && !sensor.faulty)) {
				// hide good and registered sensor in maintenance view.
				className += ` hidden`;
			}
		}
		if (sensor.dummy || this.props.dragged) {
			return (
				<div className={className} style={style} />
			);
		} else {
			if (!this.props.thumbnail) {
				return (
					<React.Fragment>
						<div className={className} style={style}
							id={"sensor" + sensor.id}
							onMouseEnter={this.onMouseEnter.bind(this)}
							onMouseLeave={this.onMouseLeave.bind(this)}
							onMouseDown={this.onMouseDown.bind(this)}
						/>
						<ToolTip active={this.state.tooltipOpen} parent={"#sensor" + sensor.id} position="right" arrow="center"
							style={{
								style: {
									background: "rgba(0,0,0,.9)",
									padding: 10,
									color: "#EEE",
									boxShadow: "0px 4px 6px rgba(0,0,0,.3)",
									borderRadius: 4
								},
								arrowStyle: {
									color: 'rgba(0,0,0,.8)',
									borderColor: false
								}
							}}
						>
							<table><tbody><tr>
								<td>
									<div>{sensor.name}</div>
									<div>{sensor.macaddress.toUpperCase()}</div>
									<div>{parentName}</div>
									{
										(!sensor.registered) ?
											<div> Maintenance {/*Change from Unregistered to Maintenance*/} </div>
											:
											(sensor.faulty ? <div>Offline since <Timestamp time={sensor.lastonl} /></div> : "")
									}
								</td>
								{
									this.props.hasPermission && <td>
										<i data-tooltip="Delete" className="material-icons cursor--pointer red-500 material--btn__icons pull-right" onClick={() => this.props.onDelete(sensor)}>delete_forever</i>
										<i data-tooltip="Edit" className="material-icons cursor--pointer material--btn__icons pull-right" onClick={() => this.props.onEdit(sensor)}>edit</i>
									</td>
								}
							</tr></tbody></table>
						</ToolTip>
					</React.Fragment>
				);
			} else {
				return (
					<div>
						<div className={className} style={style}
							data-tip data-for={"sensor" + sensor.id}
							onMouseDown={this.onMouseDown.bind(this)}
						/>
						<ReactTooltip id={"sensor" + sensor.id} place="right" type="dark" effect="solid">
							{sensor.name}<br />
							{sensor.macaddress.toUpperCase()}
						</ReactTooltip>
					</div>
				);
			}
		}
	}
}
function mapStateToProps(state) {
	return {
		nodeMap: state.overviewReducer.nodeMap
	}
}
function mapDispatchToProps(dispatch) {
	return {
		dispatch
	}
}
Sensor.propTypes = {
	nodeMap: PropTypes.object.isRequired,
	sensor: PropTypes.object.isRequired,
	viewFilter: PropTypes.object,
	onEdit: PropTypes.func,
	onDelete: PropTypes.func,
	onMouseDown: PropTypes.func,
	dragged: PropTypes.bool.isRequired,
	thumbnail: PropTypes.bool,
	hasPermission: PropTypes.bool
}
export default connect(mapStateToProps, mapDispatchToProps)(Sensor);



// WEBPACK FOOTER //
// ./src/components/pages/live/sensor.jsx